{
  "DATA_ASSISTANT": {
    "TITLE": "Асистент за данни",
    "NEW_CONVERSATION": "+ Нов",
    "LOADING": "Зареждане...",
    "LOADING_MESSAGES": "Зареждане на съобщенията...",
    "THINKING": "Мисля...",
    "UNTITLED": "Разговор без заглавие",
    "NO_CONVERSATIONS": "Все още няма разговори. Натиснете \"+ Нов\", за да започнете.",
    "EMPTY_STATE": "Изберете разговор или създайте нов, за да започнете.",
    "SEND": "Изпрати",
    "PLACEHOLDER": "Какво да открия за вас?",
    "SHOW_SQL": "Покажи SQL",
    "NO_ROWS": "Няма върнати редове.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Изтриване на разговор",
    "DELETE_CONFIRM_DESCRIPTION": "Сигурни ли сте, че искате да изтриете този разговор? Това действие не може да бъде отменено.",
    "DELETE_CONFIRM_YES": "Изтрий",
    "CHAT": "Чат",
    "REPORTS": "Отчети",
    "SAVE_TO_REPORT": "Запази в отчет",
    "NEW_REPORT": "Нов отчет",
    "REPORT_NAME": "Име на отчета",
    "NO_REPORTS": "Все още няма запазени отчети",
    "REPORTS_EMPTY_STATE": "Изберете отчет или създайте нов.",
    "REPORT_SAVED": "Запазено в отчет",
    "DELETE_REPORT_CONFIRM": "Изтриване на отчет",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Сигурни ли сте, че искате да изтриете този отчет? Всички запазени елементи ще бъдат премахнати.",
    "DELETE_ITEM_CONFIRM": "Премахване на елемент",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Сигурни ли сте, че искате да премахнете този елемент от отчета?",
    "EXPORT_CSV": "Експорт в CSV",
    "REFRESH": "Обнови",
    "QUERY_RUNNING": "Изпълнение на заявка...",
    "QUERY_FAILED": "Заявката е неуспешна",
    "AUTO_REFRESH": "Автоматично обновяване",
    "AUTO_REFRESH_NONE": "Ръчно",
    "AUTO_REFRESH_30S": "30 секунди",
    "AUTO_REFRESH_1M": "1 минута",
    "AUTO_REFRESH_5M": "5 минути",
    "AUTO_REFRESH_10M": "10 минути",
    "EDIT_MESSAGE": "Редактирай съобщение",
    "RENAME_REPORT": "Преименувай отчета",
    "RENAME_ITEM": "Преименувай елемент",
    "MOVE_UP": "Премести нагоре",
    "MOVE_DOWN": "Премести надолу",
    "COLLABORATORS": {
      "BUTTON": "Сътрудници",
      "TITLE": "Сътрудници за отчета",
      "DESCRIPTION": "Изберете кои агенти и екипи могат да виждат този отчет.",
      "AGENTS": "Агенти",
      "TEAMS": "Екипи",
      "SELECT_AGENTS": "Изберете агенти",
      "SELECT_TEAMS": "Изберете екипи",
      "SAVE": "Запази",
      "SAVED": "Сътрудниците са актуализирани",
      "SAVE_FAILED": "Неуспешно актуализиране на сътрудниците"
    }
  },
  "DATA_ASSISTANT_CHAT": "Чат",
  "DATA_ASSISTANT_REPORTS": "Отчети"
}
